export interface GiftFormState {
  buyerFirstName: string;
  buyerLastName: string;
  buyerEmail: string;
  recipientFirstName: string;
  recipientLastName: string;
  recipientEmail: string;
  deliverAt: string;
  message: string;
  reason: string;
  isGift: boolean;
  isProcessing: boolean;
}

export const defaultFormState: GiftFormState = {
  buyerFirstName: '',
  buyerLastName: '',
  buyerEmail: '',
  recipientFirstName: '',
  recipientLastName: '',
  recipientEmail: '',
  deliverAt: '',
  message: '',
  reason: 'celebration',
  isGift: false,
  isProcessing: false,
};

